
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.608 7.87l-.007-.004L1.92.946a.92.92 0 00-.868.085.963.963 0 00-.435.805V6.26a.938.938 0 00.762.92l9.1 1.683a.156.156 0 010 .307l-9.1 1.683a.937.937 0 00-.762.92V16.2a.92.92 0 00.413.769.935.935 0 00.517.156.96.96 0 00.372-.075L18.6 10.17l.007-.004a1.25 1.25 0 00.55-1.836 1.25 1.25 0 00-.55-.46z","fill":"#fff"}})])
          )
        }
      }
    